import { Factory } from '../../services/Factory';

namespace app.directives.controls {
  import IAugmentedJQuery = angular.IAugmentedJQuery;

  export interface IGravatarScope extends angular.IScope {
    account: { email: string };
  }

  export interface IGravatarAttributes extends angular.IAttributes {
  }

  export class Gravatar implements angular.IDirective {
    public restrict: string = 'E';
    public link: (scope: IGravatarScope, element: IAugmentedJQuery, attrs: IGravatarAttributes) => void;
    public template = `
            <div>
              <img ng-src="//www.gravatar.com/avatar/{{ gravatarHash }}?s=324&d={{ defaultImage }}" class="img-thumbnail" />
            </div>`;
    public scope = {account: "=ngModel"};

    constructor(MD5Service) {
      const defaultAccountImage = encodeURIComponent('https://s3.amazonaws.com/iio-assets/profile-placeholder.png');
      const defaultOrganizationImage = encodeURIComponent('https://s3.amazonaws.com/iio-assets/org-profile-placeholder.png');

      this.link = (scope: IGravatarScope) => {
        scope.$watch("account", (account: { email: string }) => {
          if (account) {
            scope.gravatarHash = MD5Service.createHash(account.email);
            if (_.has(account, "domains:")) {
              scope.defaultImage = defaultOrganizationImage;
            } else {
              scope.defaultImage = defaultAccountImage;
            }
          } else {
            scope.gravatarHash = "";
          }
        });
      };
    }
  }

  frontendApp.directive("iioGravatar", ["MD5Service", Factory.Create(Gravatar)]);
}
